const USER_APPLICATIONS = {
  UNIFIED_APPLICATION: "unified",
  PRM_APPLICATION: "prmanager",
  REVIEW_APPLICATION: "rep",
  GEO_APPLICATION: "geo",
};

export { USER_APPLICATIONS };
